import { render, staticRenderFns } from "./StatusSubscriptions.vue?vue&type=template&id=b48bf722&scoped=true&"
import script from "./StatusSubscriptions.vue?vue&type=script&lang=js&"
export * from "./StatusSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./StatusSubscriptions.vue?vue&type=style&index=0&id=b48bf722&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48bf722",
  null
  
)

export default component.exports